/**************
 Global
 ***************/

//add new product to cart
//let formData = { quantity: 1, id: 794864229, properties: { 'Personalize': 'ZHM' } };
function addProduct(formData) {
    return fetch(`${Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

//change an existing product in your cart
//let formData = { quantity: 1, id: 794864229 } or items: [{ quantity: 1, id: 794864229 }]
function changeCart(formData) {
    return fetch(`${Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

//update cart note or attributes (_ for attributes are hidden and __ are private)
//let formData = { note: 'This is a note about my order', attributes: { 'Gift wrap': 'Yes' } }
//let formData = {updates: { 794864229: 2, 794864230: 3 }}
function updateCart(formData) {
    return fetch(`${Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

// download product
function downloadProduct(handle) {
    return fetch(`${Shopify.routes.root}products/${handle}.js`)
        .then(data => data.json());
}

// get cart
function getCart() {
    return fetch(`${Shopify.routes.root}cart.js`)
        .then(data => data.json());
}

// print price (515491 => $5,154.91)
function price(amountInCents, removeTrailingZeros = false) {
    // calculate total
    let total = (parseFloat(amountInCents) / 100).toFixed(2).toString();

    // add commas if needed
    total = total.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // remove trailing zeros
    if (removeTrailingZeros) {
        total = total.toString().replace(".00", "");
    }

    // return total
    return `${currency}${total}`;
}

// sleep
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

/**************
 Design mode open mini cart
 ***************/
if (Shopify.designMode) {
    // if a user clicks on the mini cart
    document.addEventListener('shopify:section:select', function (event) {
        // open mini cart
        if (event.detail.sectionId === 'theme-mini-cart') {
            openCart();
        }
    });
}

// scroll to url hash
const maltertechParams = new URLSearchParams(window.location.search);

if (maltertechParams.get("scroll_to_class")) {
    const element = document.querySelector(`.${maltertechParams.get("scroll_to_class")}`);
    if (element) {
        window.scrollTo({
            behavior: 'smooth',
            top: element.offsetTop - 120,
        })
    }
}

if (maltertechParams.get("scroll_to_id")) {
    const element = document.querySelector(`#${maltertechParams.get("scroll_to_id")}`);
    if (element) {
        window.scrollTo({
            behavior: 'smooth',
            top: element.offsetTop - 120,
        })
    }
}

// Function to send back in stock subscription to Klaviyo
async function sendKlaviyoBackInStockRequest(emailAddress, variantID) {
    await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${await klaviyo.account()}`, {
        method: 'POST',
        headers: {
            accept: 'application/vnd.api+json',
            revision: '2024-10-15',
            'content-type': 'application/vnd.api+json'
        },
        body: JSON.stringify({
            data: {
                type: "back-in-stock-subscription",
                attributes: {
                    channels: ["EMAIL"],
                    profile: {
                        data: {
                            type: "profile",
                            attributes: {
                                email: emailAddress,
                            }
                        }
                    }
                },
                relationships: {
                    variant: {
                        data: {
                            type: "catalog-variant",
                            id: `$shopify:::$default:::${variantID}`,
                        }
                    }
                }
            }
        })
    })
}

async function openCart() {
    // UpCart (AfterSell) hides the theme's <cart-drawer> and renders its own drawer, so open it through its API
    if (typeof upcartOpenCart === "function") {
        upcartOpenCart();
        return;
    }

    // fallback if the app is ever removed
    window.location.href = `${Shopify.routes.root}cart`;
}


// restart each collection item video from the start on hover
document.querySelectorAll('.collectionItem')?.forEach((item) => {

    //Only the price data is embedded on the card (cents) - the full product JSON was too heavy for an attribute
    const price = Number(item.dataset.price);
    const compareAtPrice = Number(item.dataset.compareAtPrice);
    //The span that holds the percent off value (make sure its present to prevent errors
    const percentOffValue = item.querySelector(".dynamicPercentOffValue") || false;

    //Make sure this doesn't break if a product doesn't have a subscription option (apparel for example)
    const subRadioButton = item.querySelector(".collectionItemSubscribeInput") || false;

    //Make sure both are present before creating the listener
    if (subRadioButton && percentOffValue) {
        subRadioButton.addEventListener("change", function () {
            //Grab the selling plan price to use for percent calculation when sub is checked.
            const planPriceAdjustment = subRadioButton.dataset.planPriceAdjustment;

            if (subRadioButton.checked) { //Calculate based off of the selling plan price
                percentOffValue.innerText = `${100 - Math.round((planPriceAdjustment / compareAtPrice) * 100)}`
            } else { //calculate based off the product data otherwise
                percentOffValue.innerText = `${100 - Math.round((price / compareAtPrice) * 100)}`
            }
        })
    }

    const video = item.querySelector('video.collectionItemImage');
    if (!video) {
        return;
    }

    // the video carries preload="none", so the hover is what triggers both the download and the playback
    item.addEventListener('mouseenter', () => {
        video.currentTime = 0;
        // play() rejects when the pointer leaves before the first frame is ready, which is harmless here
        video.play().catch(() => {
        });
    });

    // stop buffering and decoding as soon as the card is no longer hovered
    item.addEventListener('mouseleave', () => {
        video.pause();
    });
});

// Collection item ATC
document.querySelectorAll('.collectionItemATC')?.forEach((button) => {
    button.addEventListener('click', async (event) => {
        event.preventDefault();
        const card = button.closest('.collectionItem');

        const formData = {
            id: button.dataset.id,
            quantity: 1,
        };

        // check for subscription — when the subscribe box is checked, add on its selling plan
        const subscribe = card.querySelector('.collectionItemSubscribeInput');
        if (subscribe?.checked) {
            formData.selling_plan = subscribe.value;
        }

        // ATC
        button.classList.add('loading');
        await addProduct({items: [formData]});
        button.classList.remove('loading');

        await openCart();
    })
})